export enum DepartmentsGT {
  Guatemala = 1,
  "El Progreso" = 2,
  Sacatepequez = 3,
  Chimaltenango = 4,
  Escuintla = 5,
  "Santa Rosa" = 6,
  Solola = 7,
  Totonicapan = 8,
  Quetzaltenango = 9,
  Suchitepequez = 10,
  Retalhuleu = 11,
  "San Marcos" = 12,
  Huehuetenango = 13,
  Quiche = 14,
  "Baja Verapaz" = 15,
  "Alta Verapaz" = 16,
  Peten = 17,
  Izabal = 18,
  Zacapa = 19,
  Chiquimula = 20,
  Jalapa = 21,
  Jutiapa = 22
}
